import { useStaticQuery, graphql } from 'gatsby'

export const useTestimonialsQuery = () => {
  const { wpPage, wp, reviewsSlider, forRatingValuePart1, forRatingValuePart2 } = useStaticQuery(
    graphql`
      query OurTestimonialsQuery {
        wpPage(title: { eq: "Home" }) {
          testimonials {
            testimonials {
              backgroundImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP)
                  }
                }
              }
              logo {
                localFile {
                  publicURL
                }
              }
              playButton {
                localFile {
                  publicURL
                }
              }
              reviewsLink {
                title
                url
              }
              reviewWidgetText
              description
              title {
                titleWhite
                titleOrange
              }
              subtitle
              videos {
                videoUrl
                image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(formats: WEBP)
                    }
                  }
                }
              }
              reviewIcons {
                googleIcon {
                  localFile {
                    publicURL
                  }
                }
                facebookIcon {
                  localFile {
                    publicURL
                  }
                }
                angiIcon {
                  localFile {
                    publicURL
                  }
                }
                localreviewsIcon {
                  localFile {
                    publicURL
                  }
                }
                merchantCircleIcon {
                  localFile {
                    publicURL
                  }
                }
                mapquestIcon {
                  localFile {
                    publicURL
                  }
                }
                yahooLocalIcon {
                  localFile {
                    publicURL
                  }
                }
              }
            }
          }
        }
        wp {
          acfOptionsCommonItems {
            commonItems {
              reviewLabel
            }
          }
        }
        reviewsSlider: allBirdeyedata(
          limit: 10
          filter: { rating: { eq: 5 }, comments: { ne: null } }
        ) {
          nodes {
            comments
            rating
            reviewer {
              firstName
              lastName
            }
            sourceType
          }
        }
        forRatingValuePart1: allBirdeyedata(
          filter: { id: { ne: "dummy" }, sourceType: { ne: "Direct Feedback" } }
        ) {
          nodes {
            rating
          }
        }
        forRatingValuePart2: allBirdeyedata(filter: { id: { ne: "dummy" }, rating: { ne: 0 } }) {
          nodes {
            rating
          }
        }
      }
    `,
  )
  return { wpPage, wp, reviewsSlider, forRatingValuePart1, forRatingValuePart2 }
}
